<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>Nascionalidade</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
         <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="Nascionalidade">Nascionalidade</label>
            <at-select v-model="currentUser.Social.Nascionalidade" filterable size="large" required="required" placeholder="Selecione...">
              <at-option v-for="(nacionality, index) in optionsNacionality" :key="`nacionalityOptions${index}`" :value="nacionality.value">{{nacionality.label}}</at-option>
            </at-select>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      optionsNacionality : [
        {value: 1, label: "Brasileira"},
        {value: 2, label: "Estrangeira"}
      ]
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {Social: this.currentUser.Social}
      this.$emit('on-submit', newData)
    }
  },
  mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/NascionalidadeStep.vue